import {ExtendedWindow} from "./head.js";

/**
 * URL input helper
 * ajout automatique du protocol
 */
let timeout:ReturnType<typeof setTimeout>|null = null;
const httpsRegex = /^(https?:\/\/)/,
	wwwStartRegex = /(^www\.|^www$)/
;

const body = document.body;
class A4iLaunchAnalysis extends HTMLElement {
	static #_initInvitationCalled = false;

	readonly #isInvitation: boolean;
	readonly #urlInput: HTMLInputElement;
	#suggestions: HTMLElement;
	#protocolPrefixSuffix: HTMLElement;
	#analyseLaunched: HTMLInputElement | null = null;
	#emailInput: HTMLInputElement | null = null;

	constructor() {
		super();

		this.#isInvitation = !body.classList.contains('history_page');

		const $urlInput = document.querySelector<HTMLInputElement>("#url");
		if (!$urlInput) {
			throw new Error("MISSING_INPUT_URL");
		}
		this.#urlInput = $urlInput;

		const $protocolPrefixSuffix = document.querySelector<HTMLInputElement>("#protocolPrefixSuffix");
		if (!$protocolPrefixSuffix) {
			throw new Error("MISSING_PROTOCOL_PREFIX_SUFFIX");
		}
		this.#protocolPrefixSuffix = $protocolPrefixSuffix;

		const $suggestions = this.form?.querySelector<HTMLElement>(".part1");
		if (!$suggestions) {
			throw new Error("MISSING_SUGGESTIONS_CONTAINER");
		}
		this.#suggestions = $suggestions;

		this.#init();
	}

	get form() {
		const $form = this.#urlInput.form;
		if (!$form) {
			throw new Error("MISSING_FORM");
		}

		const _this = this;
		this.#urlInput.addEventListener("keyup", function () {
			_this.#debounceUrlFormat(1000);
		});

		return $form;
	}
	get submitted() {
		return this.classList.contains('sent');
	}

	#init() {
		const _this = this;

		// Prevent double submissions
		this.form.addEventListener('submit', function onFormSubmit(e) {
			_this.onSubmit.call(_this, e);
		});

		if (this.#isInvitation) {
			this.#analyseLaunched = document.querySelector<HTMLInputElement>('input#analyse-launched[type="checkbox"]');
			this.#emailInput = document.querySelector<HTMLInputElement>("#address");
			if (this.#isInvitation) {
				if (!this.#emailInput) {
					throw new Error("MISSING_EMAIL");
				}
				if (!this.#analyseLaunched) {
					throw new Error("MISSING_ANALYSE_LAUNCHED");
				}
			}

			this.#initInvitation();
			this.#initInvitationOnce();
		}



		this.#protocolPrefixSuffix.addEventListener('click', function (e) {
			const el = (<HTMLElement>e.target).closest<HTMLButtonElement>('button[name]');
			if (!el || !el.name) return;

			if (el.name === "https") {
				_this.#ajouterHttps.apply(_this, arguments);
			} else if (el.name === "www") {
				_this.#ajouterWww.apply(_this, arguments);
			} else {
				_this.#ajouterSuffix.call(_this, el.name);
			}
		});

		this.#urlInput.addEventListener("input", function () {
			_this.#enableControl.apply(_this, arguments);
		});
		this.#urlInput.addEventListener("focus", function () {
			_this.#enableControl.apply(_this, arguments);
		});
		this.addEventListener("click", function (evt) {
			_this.#onResetUrl(evt);
		});
	}

	#initInvitation() {
		if (!this.#emailInput || !this.#urlInput) return;



		const _this = this;
		this.form.addEventListener("keydown", function () {
			_this.onFormKeyDown.apply(_this, arguments);
		});
		if (this.#analyseLaunched) {
			this.#analyseLaunched.addEventListener("change", function () {
				_this.onAnalyseLaunchedChange.apply(_this, arguments);
			});
		}

		document.addEventListener("change", function onEmailChange(event) {
			const element = (<HTMLElement>event.target).closest<HTMLInputElement>('input[name="address"]');
			if (!element) return;

			if (element.value) {
				document.removeEventListener('change', onEmailChange);
				try {
					(<ExtendedWindow>window).plausible('Home_input_email');
				} catch(e) {
					console.error(e);
				}
			}
		});



		// Préremplir l'email si déjà stocké
		const savedEmail = localStorage.getItem("savedEmail");
		if (savedEmail) {
			this.#emailInput.value = savedEmail;

			const consentCheck = document.querySelector<HTMLInputElement>("#consent");
			if (consentCheck && !consentCheck.checked) {
				consentCheck.click();
			}
		}
		this.#urlInput.focus();


		setTimeout(() => {
			// noinspection SpellCheckingInspection
			_this.#suggestions?.classList.add("enablecontrol");
		}, 3000);
	}
	#initInvitationOnce() {
		if (A4iLaunchAnalysis.#_initInvitationCalled) return;
		A4iLaunchAnalysis.#_initInvitationCalled = true;



		window.addEventListener('pageshow', function (event) {
			if (event.persisted) {
				// The page was restored from hibernation or back‑forward cache
				location.reload();
			}
		});

		const date = Date.now();
		document.addEventListener('visibilitychange', function onVisibilityChange() {
			if (Date.now() - date >= 300_000) {
				location.reload();
			}
		});
	}




	onSubmit(e:SubmitEvent) {
		if (this.submitted) {
			e.preventDefault();
			e.stopImmediatePropagation();
		} else {
			const emailValue = this.#emailInput?.value;
			if (emailValue) {
				localStorage.setItem("savedEmail", emailValue); // Stocker l'email
			}

			console.debug('Submitted !');
			try {
				(<ExtendedWindow>window).plausible(
					this.#isInvitation ?
						'Home_btn_submit'
						:
						'Connected_btn_submit'
				);
			} catch (e) {
				console.error(e);
			}
			const submit = this.querySelector<HTMLButtonElement>('button[type="submit"]');
			if (submit) {
				submit.disabled = true;
			}
		}
		this.classList.add('sent');
	}
	#debounceUrlFormat(delay:number) {
		if (timeout !== null) {
			clearTimeout(timeout);
			timeout = null;
		}

		const _this = this;
		const urlFormat = function urlFormat() {
			const url = _this.#urlInput.value;
			if (url !== "" && !httpsRegex.test(url)) {
				_this.#urlInput.value = `https://${url}`;
				_this.#enableControl();
			}
		}
		timeout = setTimeout(urlFormat, delay);
	}

	#enableControl() {
		const url = this.#urlInput.value,

			// Vérifier pour www
			domain = url.replace(httpsRegex, '').split('/').at(0); // Extrait

		for (let el of this.#protocolPrefixSuffix.children) {
			if (!(el instanceof HTMLButtonElement) || !el.name) continue;

			if (el.name === 'https') {
				el.disabled = httpsRegex.test(url);
			} else if (el.name === 'www') {
				el.disabled = domain?.startsWith("www.") ?? false;
			} else {
				el.disabled = domain?.endsWith('.' + el.name) ?? false;
			}
		}
	}



	/**
	 * Fonction pour ajouter https://
	 */
	#ajouterHttps() {
		const $urlInput = this.#urlInput;

		let url = $urlInput.value;
		if (!httpsRegex.test(url)) {
			$urlInput.value = `https://${url}`;
		}

		// Placer le curseur après "https://"
		setTimeout(() => {
			$urlInput.focus();
			$urlInput.setSelectionRange(8, 8); // Positionne après "https://"
		}, 10);
	}

	/**
	 * Fonction pour ajouter www
	 */
	#ajouterWww() {
		const $urlInput = this.#urlInput;

		this.#ajouterHttps();

		let url = $urlInput.value.trim(),
			positionCurseur = url.match(/^(https?:\/\/)/)?.at(0)?.length ?? 0
		;
		if (!/www\./i.test(url.replace(httpsRegex, ''))) {
			url = url.replace(httpsRegex, '$1www.');
		}

		this.#updateUrl(url, positionCurseur + 4);
	}

	/**
	 * Fonction pour ajouter ou modifier le suffixe
	 * @param suffix
	 */
	#ajouterSuffix(suffix:string) {
		const $urlInput = this.#urlInput;

		this.#ajouterHttps();

		let url = $urlInput.value.trim();
		if (!url.replace(httpsRegex, '')) {
			const positionCurseur = url.length;
			url += `.${suffix}`;
			this.#updateUrl(url, positionCurseur);
			return;
		}

		const currentUrl = $urlInput.value.trim(),
			additionalDot = currentUrl.endsWith('.') ? '.' : ''
		;
		let _url:URL;
		try {
			_url = new URL(currentUrl.replace(/\.$/, ''));
		} catch (e) {
			console.error(e);
			return;
		}

		let originalCleanedDomain = _url.hostname;
		let hadWww = false;
		if (wwwStartRegex.test(originalCleanedDomain)) {
			hadWww = true;
			originalCleanedDomain = originalCleanedDomain.replace(wwwStartRegex, ''); // Retirer "www." pour l'analyse
		}

		// Vérifier si le domaine contient déjà un suffixe
		const currentSuffixRegex = /\.[a-zA-Z]{2,}$/;
		if (!currentSuffixRegex.test(originalCleanedDomain)) {
			_url.hostname += `${additionalDot}.${suffix}`; // Ajouter si aucun suffixe
		} else {
			_url.hostname = originalCleanedDomain.replace(currentSuffixRegex, `${additionalDot}.${suffix}`); // Remplacer l'ancien suffixe
			if (hadWww) {
				_url.hostname = `www.${_url.hostname}`;
			}
		}


		/**
		 * position curseur = protocol + domain + path - (si input invalide : longueur du suffixe et le point)
		 */
		const positionCurseur = _url.protocol.length + 2 + _url.host.length - ($urlInput.checkValidity() ? 0 : 1) * (suffix.length + 1);
		this.#updateUrl(_url, positionCurseur);
	}

	#updateUrl(url: URL|string, positionCurseur: number) {
		const $urlInput = this.#urlInput;

		if (typeof url !== 'string') {
			const slashEnd = $urlInput.value.endsWith('/'),
				newUrl = url.toString()
			;
			$urlInput.value = slashEnd ? newUrl : $urlInput.value = newUrl.replace(/\/$/i, '');
		} else {
			$urlInput.value = url;
		}

		setTimeout(() => {
			$urlInput.focus();
			$urlInput.setSelectionRange(positionCurseur, positionCurseur);
		}, 10);
	}
	#onResetUrl(evt:Event) {
		const el = (<HTMLElement>evt.target).closest('#reset-input-url');
		if (!el) return;
		this.#urlInput.value = '';
		evt.preventDefault();
	}





	onFormKeyDown(event:KeyboardEvent) {
		if (!this.#emailInput || !this.#analyseLaunched) return;

		// Vérifier si la touche pressée est la touche "Entrée" (code 13)
		if (!event.code || event.code.toLowerCase() !== "enter" || this.#analyseLaunched.checked) return;


		const consentChecked = document.querySelector<HTMLInputElement>("#consent")?.checked ?? false;
		if (!consentChecked) {
			if (this.#urlInput.checkValidity() && !this.#analyseLaunched.checked) {
				this.#analyseLaunched.click();
			}
			event.preventDefault(); // Empêcher l'envoi du formulaire par la touche Entrée
		}
	}

	/**
	 * Mettre le focus sur le champ mail dès que l'URL est rempli
	 */
	onAnalyseLaunchedChange(event:Event) {
		if (!this.#emailInput) return;

		console.debug(event);
		this.#emailInput.focus();
		try {
			(<ExtendedWindow>window).plausible('Home_btn_check');
		} catch(e) {
			console.error(e);
		}
	}
}
customElements.define('a4i-launch-analysis', A4iLaunchAnalysis);

document.addEventListener('click', function (evt) {
	const el = (<HTMLElement|null>evt.target)?.closest('#launch_analysis_new');
	if (!el) return;

	el.closest('a4i-launch-analysis')?.classList.remove('sent');
});
